export const routes = {
  web: {
    auth: {
      login: "/auth/login",
      register: "/auth/register",
      forgotPassword: "/auth/forgot-password",
      resetPassword: "/auth/reset-password",
      verify: "/auth/verify",
      socialLogin: "/auth/social-login",
    },
    dashboard: {
      home: "/",
    },
    users: {
      profile: "/users/profile",
      tickets: "/users/tickets",
    },
    terms: "/terms",
    privacy: "/privacy",
    contact: "/contact",
  },
  api: {
    auth: {
      login: "/api/auth/login",
      register: "/api/auth/register",
      forgotPassword: "/api/auth/forgot-password",
      resetPassword: "/api/auth/reset-password",
      socialLogin: "/api/auth/social-login",
      verify: "/api/auth/verify",
    },
    events: {
      list: "/api/events",
    },
    users: {
      profile: "/api/users/profile",
      changePassword: "/api/users/change-password",
      delete: "/api/users/delete",
    },
  },
};
